//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { TaxInputItem } from './TaxInputItem';
import { PayrollInputItem } from './PayrollInputItem';

export class PaymentOrReturnPayrollInputItem extends PayrollInputItem {
    PaymentMethod: string | null = null;
    CashCategoryID: string | null = null;
    Taxes: TaxInputItem[] = [];

    constructor(initializer?: Partial<PaymentOrReturnPayrollInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "PaymentOrReturnPayrollInputItem";
}
